import React, { useState } from "react";
import { createPayLink } from "../services/helioService";

interface BuyButtonProps {
  onSaleComplete: () => void;
}

const BuyButton: React.FC<BuyButtonProps> = ({ onSaleComplete }) => {
  const [loading, setLoading] = useState(false);

  const handleBuyClick = async () => {
    setLoading(true);
    try {
      const paymentLink = await createPayLink();
      window.open(paymentLink, "_blank");
      setTimeout(() => {
        onSaleComplete();
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Payment error:", error);
      setLoading(false);
    }
  };

  return (
    <button className="buy-button" onClick={handleBuyClick} disabled={loading}>
      {loading ? "Processing..." : "BUY NOW"}
    </button>
  );
};

export default BuyButton;
